import React from "react"
import PropTypes from "prop-types"

const Vide = ({ fillColor, width, height }) => (
  <svg
    id="Calque_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 70 58"
    width={width}
    height={height}
  >
    <path
      fill="#53aae3"
      d="M61.01,52.53c.08,.11,.15,.22,.23,.33,1.09-.2,2.19-.35,3.29-.45-.02-.05-.04-.09-.06-.14-4.76-8.01-10.05-15.71-14.95-23.63-4.9-7.92-9.45-16.16-14.64-23.87-.6-.89-1.75-.67-2.24,.03-.17,.12-.33,.28-.46,.5-4.67,7.5-9.05,15.19-13.55,22.79-4.5,7.59-9.23,15.11-13.38,22.9,0,.01,0,.02-.02,.04h-.04c-1.15,.23-1.27,2.2-.12,2.39,4.25,.71,8.95,.16,13.29,.1,4.64-.06,9.28-.13,13.92-.21,9.28-.15,18.56-.26,27.84-.45,.37,0,.67-.13,.91-.32m-28.59-2.28c-4.64,.08-9.28,.16-13.92,.25-3.24,.06-6.67-.15-9.99,.09,4.41-6.85,8.43-13.98,12.6-20.97,4.21-7.07,8.55-14.09,12.64-21.23,4.05,7.62,8.8,14.91,13.32,22.2,3.97,6.41,7.88,12.94,12.08,19.21-8.91,.12-17.82,.29-26.73,.44"
    />
  </svg>
)

Vide.propsTypes = {
  fillColor: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
}

Vide.defaultProps = {
  fillColor: "currentColor",
  width: "60px",
  height: "60px",
}

export { Vide }
